import React from 'react';

const Chevron = () => (
  <svg
    version="1.1"
    id="chevron"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 12.5 6.2"
    style={{ enableBackground: 'new 0 0 12.5 6.2' }}
  >
    <polygon style={{ fill: '#888888' }} points="0.8,0.5 11.6,0.5 6.2,5.9 " />
  </svg>
);

export default Chevron;
